import {
  DoBoxRuleDecision,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createDoBoxRuleDecisionMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: DoBoxRuleDecision) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
        case WebSocketAction.MODIFY:
          log.debug('[DoBoxRuleDecisionHandler] %s DoBoxRuleDecision', action);
          eventEmitter.emit(
            WebSocketEntityType.DoBoxRule,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        default:
          log.warn(
            '[DoBoxRuleDecisionHandler] Unknown action for DoBoxRule:',
            action,
          );
      }
    } catch (error) {
      log.error('[DoBoxRuleDecisionHandler] Handler failed:', error);
    }
  };
}
